import React, { createContext, useContext, useMemo } from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/tableViewStore';
import ContainerlessTableViewContainer from '../containers/ContainerlessTableViewContainer';

export const ContainerlessTableViewContext = createContext({});

export const useContainerlessTableViewContext = () => useContext(ContainerlessTableViewContext);

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const ContainerlessTableViewApp = ({ hiddenFilterParams = [], ...props }) => {
  const store = useMemo(() => configureStore(props), []);

  return (
    <Provider store={store}>
      <ContainerlessTableViewContext.Provider value={{ hiddenFilterParams }}>
        <ContainerlessTableViewContainer />
      </ContainerlessTableViewContext.Provider>
    </Provider>
  );
};

export default ContainerlessTableViewApp;
